module.exports = "<app-ct-menu></app-ct-menu>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/correspondance-tracking/correspondance-tracking.component.html
// module id = ./src/app/correspondance-tracking/correspondance-tracking.component.html
// module chunks = main